import { displayElementBelowTarget } from 'utilities/element-position';

function countProps(obj) {
  var count = 0;
  for (let index in obj) {
    if (obj.hasOwnProperty(index)) {
      count++;
    }
  }
  return count;
}

export function compareTwoValuesEquality(objectA, objectB) {

  if (typeof(objectA) !== typeof(objectB)) {
    return false;
  }

  if (typeof(objectA) === 'function') {
    return objectA.toString() === objectB.toString();
  }

  if (objectA instanceof Object && objectB instanceof Object) {
    if (countProps(objectA) !== countProps(objectB)) {
      return false;
    }
    var r = true;
    for (let index in objectA) {
      r = compareTwoValuesEquality(objectA[index], objectB[index]);
      if (!r) {
        return false;
      }
    }
    return true;
  } else {
    return objectA === objectB;
  }
}

export function positionSingleSelectOptions(singleSelectOptionsListElement, selectButtonElement, optionsWidth = 0) {

  displayElementBelowTarget(singleSelectOptionsListElement, selectButtonElement);

  const boundingRectangle = selectButtonElement.getBoundingClientRect();
  let width = optionsWidth;

  if (width === 0) {
    width = boundingRectangle.width;
  }

  singleSelectOptionsListElement.style['max-width'] = width + 'px';

}

export function getNativeOptionValue(option, valueFieldName) {

  const value = option[valueFieldName];

  if (value === void 0) {
    return option;
  }

  return value;

}

export function buildNativeOptions(options, labelFieldName, valueFieldName) {

  const nativeOptions = [];

  for (let option of options) {

    const nativeOption = {
      ...option,
      label: option[labelFieldName] || option.label,
      value: getNativeOptionValue(option, valueFieldName)
    };

    nativeOptions.push(nativeOption);

  }

  return nativeOptions;

}

export function buildSelectedOptionsLabel(options, selectedOptionIndices) {

  const labels = [];

  for (let index of selectedOptionIndices) {

    labels.push(options[index].label);

  }

  return labels.join(', ');

}

export function getSelectedOptionValues(options, selectedOptionIndices) {

  const selectedOptions = [];
  const values = [];

  for (let index of selectedOptionIndices) {

    const option = options[index];

    selectedOptions.push(option);
    values.push(option.value);

  }

  return { values, options: selectedOptions };

}